import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";

const reviews = [
 {
    name: "Nandhini Kishore",
    date: "2025-06-16",
    review:
      "I recently attended a one-day workshop at finesse Baking Academy, and it was a fantastic experience. The instructors were knowledgeable and passionate, guiding us through essential baking techniques in a hands-on environment. We learned to make a variety of cookies and received helpful tips along the way. The small class size fostered a supportive atmosphere, making it easy to ask questions. By the end of the day, I left with a selection of delicious treats and newfound confidence in my baking skills. I highly recommend this workshop for anyone looking to improve their baking!",
    rating: 5,
  },
  {
    name: "Jyothi B.L.S",
    date: "2025-06-16",
    review:
      "I have attended a choux pastry class at Finesse Academy for baking. The instructions were very clear and easy to follow, which really helped me feel confident even though I was trying something new. The chef was so patient and took the time to explain all the little tips and tricks that make a big difference in pastry making. It was a hands-on experience. Highly recommend if you want to learn something new in baking.",
    rating: 5,
  },
  {
    name: "Adhnaan Ahmed",
    date: "2025-06-13",
    review:
      "Chef Mr.Shuaib is a very professional in his baking skills and also sharing his expertise was the limelight, it was worth every penny and I would recommend anyone who who is seeking to learn, then this is one place to go.",
    rating: 4,
  },
  { name: "Dr. Priyasampath", rating: 5, review: "I have zero knowledge in cooking and baking … I attended workshop on cookies and brownie.mentor MD shuaib sir teaches me from the basics and in a pleasant way… and I wish to learn more from him" },
  { name: "Thebloompie bakery", rating: 4, review: "It was a good experience to learn with the chief. He taught in depth about all ingredients which reacted to what. I learn science behind all ingredients . Thank finesse academy" },
  { name: "Hajera", rating: 5, review:
      "The instructor was friendly, patient and answered all the questions. I had a fantastic time at the brownie workshop. Keep rocking ", },
];
const Testimonial = () => {
  const [slides, setSlides] = useState([]);

  // Function to group reviews based on screen width
  const groupReviews = () => {
    const width = window.innerWidth;
    let perSlide = 3; // default large screens

    if (width < 768) perSlide = 1; // small devices
    else if (width >= 768 && width < 992) perSlide = 2; // tablets

    const grouped = [];
    for (let i = 0; i < reviews.length; i += perSlide) {
      grouped.push(reviews.slice(i, i + perSlide));
    }
    setSlides(grouped);
  };

  useEffect(() => {
    groupReviews(); // initial
    window.addEventListener("resize", groupReviews);
    return () => window.removeEventListener("resize", groupReviews);
  }, []);

  return (
    <div className="testimonial-slider py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left title */}
          <div className="col-md-2 mb-4 mb-md-0 text-dark">
            <div
              className="p-4 text-center shadow rounded"
              style={{ minWidth: "230px", backgroundColor: "#fff" }}
            >
              <h4 className="fw-bold">EXCELLENT</h4>
              <div className="mb-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star" style={{ color: "#fbbc04" }}></i>
                ))}
              </div>
              <p className="mb-1">Based on <b>17 reviews</b></p>
              <div className="d-flex justify-content-center align-items-center gap-1">
                <i className="fa-brands fa-google" style={{ color: "#4285F4", fontSize: "24px" }}></i>
                <span className="fw-bold fs-5 text-primary">Google</span>
              </div>
            </div>
          </div>

          {/* Right carousel */}
          <div className="col-md-10 col-sm-12">
            <Carousel indicators={false} controls={true} interval={null}>
              {slides.map((group, index) => (
                <Carousel.Item key={index}>
                  <div className="d-flex justify-content-center flex-wrap">
                    {group.map((r, idx) => (
                      <div className="card testimonial-card p-3 m-2" key={idx}>
                        <div className="d-flex align-items-center mb-2">
                          <h5 className="mb-0 me-2">{r.name}</h5>
                        </div>
                        <div className="mb-2">
                          {[...Array(r.rating)].map((_, i) => (
                            <i key={i} className="fa-solid fa-star" style={{ color: "#fbbc04" }}></i>
                          ))}
                        </div>
                        <p className="mb-0">{r.review}</p>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
